export const disableGSFields = (profile_type) => {
  if (profile_type === 'MIXED' || profile_type === 'MIXED_DEPENDENT') {
    return true;
  }
  return false;
};
